import { callApiToServer } from "../callApi";

export async function addCategory(authtoken, categoryObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      name: categoryObject.name,
      type: categoryObject.type,
      background: categoryObject.background,
      forground: categoryObject.forground,
      accent: categoryObject.accent,
      icon_name: categoryObject.icon_name,
    });

    let endUrl = "v1/auth/category";

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
